import React, { FC } from 'react'

import { IconAdultProps } from './IconAdult.types'
import * as Styled from './styles/IconAdult.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAdult: FC<IconAdultProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAdultProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconAdultProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M49 40.51a4 4 0 0 0-4 .08L24.74 52.92a4 4 0 0 0 4.17 6.83L43 51.13V114a4 4 0 0 0 8 0V44a4 4 0 0 0-2-3.49zM140 76h-8v-8a4 4 0 0 0-8 0v8h-8a4 4 0 0 0 0 8h8v8a4 4 0 0 0 8 0v-8h8a4 4 0 0 0 0-8zm-42.87 3.29A21.25 21.25 0 0 0 107 61.5C107 49.65 96.91 40 84.5 40S62 49.65 62 61.5A21.21 21.21 0 0 0 71.44 79C64 82.81 59 89.9 59 98c0 12.13 11.21 22 25 22s25-9.87 25-22c0-7.9-4.75-14.83-11.87-18.71zM84.5 48c8 0 14.5 6.06 14.5 13.5S92.5 75 84.5 75 70 68.94 70 61.5 76.5 48 84.5 48zm-.5 64c-9.37 0-17-6.28-17-14s7.63-14 17-14 17 6.28 17 14-7.63 14-17 14z' />
        <path d='M80 0a80 80 0 1 0 80 80A80.09 80.09 0 0 0 80 0zm0 152a72 72 0 1 1 72-72 72.08 72.08 0 0 1-72 72z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconAdult
